import { List, ListItem, ListItemIcon, ListItemText, ListSubheader } from "@mui/material"
import rics from "routes/schedule/plugins/codes-tab/rics.png"
import uniclass from "routes/schedule/plugins/codes-tab/uniclass.png"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function Codes() {
    const { target } = useBoundContext()
    return (
        <List data-cy="schedule-codes">
            {!!target.nrm.length && (
                <>
                    <ListSubheader>NRM</ListSubheader>
                    {target.nrm.map((entry) => (
                        <ListItem key={entry.code} data-cy="schedule-code-row">
                            <ListItemIcon>
                                <img src={rics} width={32} alt="Rics logo" height={32} />
                            </ListItemIcon>
                            <ListItemText primary={entry.description} secondary={entry.code} />
                        </ListItem>
                    ))}
                </>
            )}
            {!!target.uniclass.length && (
                <>
                    <ListSubheader>Uniclass</ListSubheader>
                    {target.uniclass.map((entry) => (
                        <ListItem key={entry.code} data-cy="schedule-code-row">
                            <ListItemIcon>
                                <img src={uniclass} width={32} alt="Uniclass logo" height={32} />
                            </ListItemIcon>
                            <ListItemText primary={entry.description} secondary={entry.code} />
                        </ListItem>
                    ))}
                </>
            )}
        </List>
    )
}
